module.exports = __webpack_public_path__ + "static/img/bg3.fb6564f2.png";